<template>
  <ModalTunnel 
    :visible="visible"
    :closeOnExternalClick="false"
    :nbPages="3"
    :headerProps="{
      closeButton: true,
      displayProgression: true,
    }"
    :displayNavigation="false"
    ref="refTunnel"
    width="700px"
    @close="onClose"
  >
    <!-- Criticality -->
    <template #[`content-${pages.CRITICALITY.pageNum}`]>
      <MPCCriticality 
        :criticality="criticality"
        @update:criticality="$emit('update:criticality', $event);goToPage(pageKeys.GPU);" 
      />
    </template>

    <template #[`footer-${pages.CRITICALITY.pageNum}`]>
      <MPFDefault
        :previousLabel="pages.CRITICALITY.previousLabel" 
        :nextLabel="pages.CRITICALITY.nextLabel"
        @previous="onClose" 
        @next="goToPage(pageKeys.GPU)"
      />
    </template>
    <!-- / Criticality  -->

    <!-- GPU -->
    <template #[`content-${pages.GPU.pageNum}`]>
       <MPCGPU 
        :requireGPU="requireGPU"
        @update:requireGPU="$emit('update:requireGPU', $event);goToPage(pageKeys.LOCATION);" 
      />
    </template>

    <template #[`footer-${pages.GPU.pageNum}`]>
      <MPFDefault
        :nextLabel="pages.GPU.nextLabel"
        :previousLabel="pages.GPU.previousLabel"
        @previous="goToPage(pageKeys.CRITICALITY)" 
        @next="goToPage(pageKeys.LOCATION)"
      />
    </template>
    <!-- / GPU  -->

    <!-- Location -->
    <template #[`content-${pages.LOCATION.pageNum}`]>
      <MPCLocation 
        :selectedCountry="selectedCountry"
        @update:selectedCountry="onSelectCountry($event);onClose();" 
      />
    </template>

    <template #[`footer-${pages.LOCATION.pageNum}`]>
      <MPFDefault
        :nextLabel="pages.LOCATION.nextLabel"
        :previousLabel="pages.LOCATION.previousLabel"
        @previous="goToPage(pageKeys.GPU)" 
        @next="onClose"
      />
    </template>
    <!-- / Location  -->
  </ModalTunnel>
</template>

<script lang="ts">
import { Vue, Options, prop } from 'vue-class-component'
import { ref } from 'vue'

import ModalTunnel from '@/components/UIElements/ModalTunnel.vue'
import MPCCriticality from '@/components/Modals/Partials/Contents/MPCCriticality.vue'
import MPCGPU from '@/components/Modals/Partials/Contents/MPCGPU.vue'
import MPCLocation from '@/components/Modals/Partials/Contents/MPCLocation.vue'
import MPFDefault from '@/components/Modals/Partials/Footers/MPFDefault.vue'
import { Watch } from 'vue-property-decorator'
import { ListItem } from '@/components/UIElements/List.vue'

class Props {
  visible: boolean = prop({
    required: true,
  });
  criticality: string = prop({
    required: true,
  });
  requireGPU: boolean = prop({
    required: true,
  });
  selectedCountry?: ListItem = prop({
    required: false,
  });
}

interface Page {
  pageNum: number,
  header?: string,
  nextLabel?: string,
  previousLabel?: string,
}

@Options({
  components: {
    ModalTunnel,
    MPCCriticality,
    MPCGPU,
    MPCLocation,
    MPFDefault
  },
})
export default class ModalClusterConfigWizard extends Vue.with(Props) {
  refTunnel: any = ref(null)
  nbTunnelPages = 4;
  pageKeys = {
    CRITICALITY: 'CRITICALITY',
    GPU: 'GPU',
    LOCATION: 'LOCATION',
  }
  pages:{[key:string]:Page} = {
    [this.pageKeys.CRITICALITY]: {
      pageNum: 0,
      previousLabel: "Cancel",
      nextLabel: "Skip",
    },
    [this.pageKeys.GPU]: {
      pageNum: 1,
      previousLabel: "Previous",
      nextLabel: "Skip",
    },
    [this.pageKeys.LOCATION]: {
      pageNum: 2,
      previousLabel: "Previous",
      nextLabel: "Close wizard",
    }
  }
  currentPageKey = 'CRITICALITY'

  goToPage(pageKey:string) {
    this.currentPageKey = pageKey
    this.refTunnel?.goToPage(this.pages[pageKey].pageNum)
  }

  onClose() {
    this.$emit('update:visible', false)
  }

  onSelectCountry(country: ListItem): void {
    if (country) {
      this.$emit('update:selectedCountry', country);
    } else {
      this.onClose();
    }

  }

  @Watch('visible', {immediate: true})
  onCriticalityChange() {
    if(this.visible) {
      this.goToPage(this.pageKeys.CRITICALITY);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/variables';
</style>
